/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { NotificationType } from './NotificationType'
import {
  NotificationTypeFromJSON,
  NotificationTypeFromJSONTyped,
  NotificationTypeToJSON,
} from './NotificationType'

/**
 *
 * @export
 * @interface UserNotificationData
 */
export interface UserNotificationData {
  /**
   *
   * @type {NotificationType}
   * @memberof UserNotificationData
   */
  type?: NotificationType
  /**
   *
   * @type {number}
   * @memberof UserNotificationData
   */
  applicationId?: number | null
  /**
   *
   * @type {string}
   * @memberof UserNotificationData
   */
  regNumber?: string | null
  /**
   *
   * @type {string}
   * @memberof UserNotificationData
   */
  text?: string | null
  /**
   *
   * @type {string}
   * @memberof UserNotificationData
   */
  path?: string | null
  /**
   *
   * @type {string}
   * @memberof UserNotificationData
   */
  number?: string | null
}

/**
 * Check if a given object implements the UserNotificationData interface.
 */
export function instanceOfUserNotificationData(
  value: object
): value is UserNotificationData {
  return true
}

export function UserNotificationDataFromJSON(json: any): UserNotificationData {
  return UserNotificationDataFromJSONTyped(json, false)
}

export function UserNotificationDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserNotificationData {
  if (json == null) {
    return json
  }
  return {
    type:
      json['type'] == null ? undefined : NotificationTypeFromJSON(json['type']),
    applicationId:
      json['applicationId'] == null ? undefined : json['applicationId'],
    regNumber: json['regNumber'] == null ? undefined : json['regNumber'],
    text: json['text'] == null ? undefined : json['text'],
    path: json['path'] == null ? undefined : json['path'],
    number: json['number'] == null ? undefined : json['number'],
  }
}

export function UserNotificationDataToJSON(
  value?: UserNotificationData | null
): any {
  if (value == null) {
    return value
  }
  return {
    type: NotificationTypeToJSON(value['type']),
    applicationId: value['applicationId'],
    regNumber: value['regNumber'],
    text: value['text'],
    path: value['path'],
    number: value['number'],
  }
}
